export default "__VITE_ASSET__Ct02tGg1__"